var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"labelRate_List"},[_vm._l((_vm.onCnt),function(n){return _c('tk-icon',{key:`tkrate_on-navItem__${n}`,attrs:{"name":_vm.onIcon}})}),(_vm.onHalfCnt > 0)?_c('tk-icon',{attrs:{"name":_vm.halfIcon}}):_vm._e(),_vm._l((_vm.offCnt),function(n){return _c('tk-icon',{key:`tkrate_off-navItem__${n}`,attrs:{"name":_vm.offIcon}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }